export default __webpack_public_path__ + "static/media/paddlepaddleQr.b515426d.jpg";